<template lang="pug">
w-app.w-flex
  w-drawer.main-menu(
    v-model="menuVisible"
    width="250px"
  )
    div.w-flex.column
      div.close-row.w-flex
        w-icon(
          style="cursor:pointer;"
          color="black"
          xl
          @click="toggleMenu"
        ) mdi mdi-window-close
      //- router-link(
      //-   :to="{ name: 'Aktuelles' }"
      //- ) Aktuelles
      //- w-divider.mx4(color="red")
      router-link(
        :to="{ name: 'Team' }"
      ) Team
      w-divider.mx4(color="red")
      router-link(
        :to="{ name: 'Leitfaden' }"
      ) Leitfaden
      w-divider.mx4(color="red")
      router-link(
        :to="{ name: 'Tagesablauf' }"
      ) Tagesablauf
      w-divider.mx4(color="red")
      router-link(
        :to="{ name: 'Anmeldung' }"
      ) Anmeldung
  w-flex(column)
    header.main-header
      w-toolbar(shadow)
        router-link(
          :to="{ name: 'Startseite' }"
        )
          w-image(
            tag="img"
            :src="require('@/assets/logo.png')"
            width="50px"
            height="50px"
            contain
          )
        a.ml3(
          @click="$router.push({name: 'Startseite'})"
          style="cursor: pointer;"
        ) Schmetterlinge e.V.
        div.spacer
        template(v-if="expandMenu")
          //- router-link(
          //-   :to="{ name: 'Aktuelles' }"
          //- )
          //-   span Aktuelles
          //- w-divider.mx6(vertical color="red")
          router-link(
            :to="{ name: 'Team' }"
          )
            span Team
          w-divider.mx6(vertical color="red")
          router-link(
            :to="{ name: 'Leitfaden' }"
          )
            span Leitfaden
          w-divider.mx6(vertical color="red")
          router-link(
            :to="{ name: 'Tagesablauf' }"
          )
            span Tagesablauf
          w-divider.mx6(vertical color="red")
          router-link(
            :to="{ name: 'Anmeldung' }"
          )
            span.mr4 Anmeldung
        w-icon(
          v-else
          style="cursor:pointer;"
          color="black"
          xl
          @click="toggleMenu"
        ) mdi mdi-menu
    router-view(v-slot="{ Component }")
      component.grow(:is="Component" class="main-content")
    footer.main-footer(shadow)
      w-toolbar.w-flex.column(shadow)
        div.footer-content.w-flex.wrap
          div.footer-kontakt.column.sidebyside-content.w-flex.align-center
            h2.footer-title Kontakt
            div
              div.text-bold Schmetterlinge e.V.
              div.adresse
                a(href="https://goo.gl/maps/QdXqQRKdCP58BQoP9" target="_blank")
                  div Berliner Str.1
                  div 71083 Herrenberg
              div &nbsp;
              div 
                w-icon.mr2(
                  color="black"
                ) mdi mdi-phone
                a(href="tel:+49703228183")
                  | 07032 – 28 183
              div
                w-icon.mr2(
                  color="black"
                ) mdi mdi-email
                a(href="mailto:info@schmetterlinge-herrenberg.de")
                  | info@schmetterlinge-herrenberg.de
              div &nbsp;
              div.text-bold Öffnungszeiten:
              div Mo.-Fr. 07:30 bis 13:30 Uhr.
          div.footer-sponsor.column.sidebyside-image.w-flex.align-center
            h2.footer-title Fördermitglieder
            div.sponsor-icons.w-flex.wrap.justify-space-around
              template(
                v-for="sponsor in sponsors"
              )
                a(
                  v-if="sponsor.link"
                  :href="sponsor.link" 
                  target="_blank"
                )
                  w-image(
                    :title="sponsor.name"
                    style="padding:5px;"
                    tag="img"
                    :src="sponsor.image"
                    width="130px"
                    height="65px"
                    contain
                  )
                w-image(
                  v-else
                  :title="sponsor.name"
                  style="padding:5px;"
                  tag="img"
                  :src="sponsor.image"
                  width="130px"
                  height="65px"
                  contain
                )
        w-divider.footer-links-divider
        div.footer-links.w-flex.wrap
          div 
            router-link(
              :to="{ name: 'Impressum' }"
            ) Impressum
          w-divider.mx6(vertical color="red")
          div
            router-link(
              :to="{ name: 'Datenschutz' }"
            ) Datenschutzerklärung
          w-divider.mx6(vertical color="red")
          div.mr6 
            router-link(
              :to="{ name: 'Verein' }"
            ) Verein
          div.grow.text-right &copy; 2026 Schmetterlinge e.V.
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import WebFontLoader from 'webfontloader';

export default {
  name: 'App',
  data() {
    return {
      sponsors: [
        // {
        //   name: "Bäcker Baier, Herrenberg (Inh. Jochen Baier)", 
        //   link: "https://www.baecker-baier.de",
        //   image: require('@/assets/sponsors/baier.png')
        // },
        { 
          name: "Metallbau Dongus, Herrenberg (Inh. Rainer Dongus)", 
          link: "https://www.metallbau-dongus.de",
          image: require('@/assets/sponsors/dongus.png')
        },
        { 
          name: "Alte Brennerei / Getränke Holz, Herrenberg (Inh. Peter Holz)", 
          link: "https://www.getraenke-holz.de",
          image: require('@/assets/sponsors/holz.png')
        },
        // {
        //   name: "Keimling Naturkost, Herrenberg (Inh. Susanne Koch)",
        //   link: "https://keimling-herrenberg.de",
        //   image: require('@/assets/sponsors/keimling.png')
        // },
        {
          name: "Architektur-Team, Herrenberg (Inh. Herbert Mayer)", 
          image: require('@/assets/sponsors/architektur-team.png')
        },
      ]
    };
  },
  computed: {
    ...mapGetters('global',{
      portrait: 'portrait',
      showMenu: 'showMenu',
      viewport: 'viewport',
    }),
    expandMenu() {
      return this.viewport.width>=800
    },
    menuVisible: {
      get() {
        return this.showMenu && !this.expandMenu
      },
      set(state) {
        state ? this.openMenu() : this.closeMenu()
      }
    }
  },
  beforeMount() {
    document.body.classList.toggle('portrait',this.portrait)
  },
  mounted() {
    this.$nextTick(() => window.addEventListener('resize', this.onResize));
    this.onResize();
  },
  beforeUnmount() { 
    window.removeEventListener('resize', this.onResize); 
  },  
  created() {
    WebFontLoader.load({
      custom: {
        families: ['Patrick Hand']
      },
      active: this.setFontLoaded,
    });
  },
  methods: {
    ...mapMutations('global', {
      setViewport: 'setViewport',
    }),
    ...mapActions('global',{
      toggleMenu: 'toggleMenu',
      closeMenu: 'closeMenu',
      openMenu: 'openMenu',
    }),
    onResize() {
      this.setViewport({width: window.innerWidth, height: window.innerHeight})
    },
    scrollTo(selector,offset=80) {
      let elem = document.querySelector(selector);
      if (elem) {
        let elemtop = 0;
        if (elem.offsetParent) {
          do {
            elemtop += elem.offsetTop;
            elem = elem.offsetParent;
          } while (elem);
        }
        window.scrollTo({
          top: elemtop - offset, 
          behavior: 'smooth'
        });
      }
    },
    setFontLoaded() {
      console.log('font-loaded');
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = 'Die Schmetterlinge - ' + to.name;
        if (!to.params.dummy && (from && !from.params.dummy)) {
          console.log('test');
          window.scrollTo({
            top: 0, 
            //behavior: 'smooth'
          });
        }
        this.closeMenu()
      }
    },
    portrait(portrait) {
      document.body.classList.toggle('portrait',portrait)
    },
    expandMenu(expand) {
      if (expand) this.closeMenu()
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Patrick Hand', 'Comic Sans MS', Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  justify-content: center;
  background-color: rgb(255,250,250);
  font-size: 18px;

  h1 {
    font-size: 30px; 
    font-weight:1000;
  }
  h2 {
    font-size: 20px;
    font-weight: 1000;
  }
  h3 {
    font-size: inherit;
    font-weight: bold;
  }

  .w-image-wrap {
    display: block;
    > img {
      display: block;
    }
  }
  .w-toolbar {
    padding: 10px 12px;
  }
}
a{
  color: black;
}
a:hover{
  color: red
}
a.router-link-active{
  color: red;
  font-weight: bold
}
.w-app{
  background-color: white;
  width:100%;
  max-width: 1100px;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 15%), 0 1px 5px 0 rgb(0 0 0 / 15%);
}
.main-header{
  position: sticky;
  top: 0;
  z-index: 100;
}
.main-menu {
  a {
    text-align: center;
    font-size: 20px;
    padding: 20px 20px;
  }
  .close-row {
    height: 70px;
    flex-grow: 0;
    align-items: center;
    align-self: flex-end;
    padding: 10px;
  }
}
.main-footer{
  margin-top: 0;
  .footer-links-divider {
    width: 100%
  }
  .footer-links {
    font-size: smaller;
    padding: 5px;
    width: 100%;
  }
  .footer-title {
    font-size: larger!important;
  }
  .sponsor-icons {
    align-content: start;
  }
  .adresse {
    width: fit-content;
  }
  .footer-content{
    width: 100%;
    .column{
      flex-basis: 300px;
      flex-grow: 1;
      padding: 20px;
    }
  } 
}
</style>
